import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon'
import { COLOR } from 'vars/color'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
  ButtonIconSizes,
  IconPositions,
} from '../Button.h'

export interface IInlineFontButton2ForwardButtonProps extends IButtonProps {}

export const InlineFontButton2ForwardButton = ({
  title = '',
  icon = IconNames.angleRight,
  iconPosition = IconPositions.Right,
  iconSize = ButtonIconSizes.sm,
  corners = ButtonCorners.CORNERS_10,
  colorDefault = ButtonColors.COLOR_MAIN_DEFAULT,
  colorHovered = ButtonColors.SURFACE_LIGHT_2,
  colorPressed = ButtonColors.COLOR_MAIN_PRESSED,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault = COLOR.TRANSPARENT,
  backgroundColorDisabled = COLOR.TRANSPARENT,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font = ButtonFonts.Button2,
  fluid = ButtonFluid.None,
  ...rest
}: IInlineFontButton2ForwardButtonProps): JSX.Element => (
  <Button
    title={title}
    icon={icon}
    iconPosition={iconPosition}
    iconSize={iconSize}
    corners={corners}
    colorDefault={colorDefault}
    colorHovered={colorHovered}
    colorPressed={colorPressed}
    colorDisabled={colorDisabled}
    backgroundColorDefault={backgroundColorDefault}
    backgroundColorDisabled={backgroundColorDisabled}
    borderWidth={borderWidth}
    font={font}
    fluid={fluid}
    {...rest}
  />
)

InlineFontButton2ForwardButton.displayName = 'InlineFontButton2ForwardButton'
